module.exports = __webpack_public_path__ + "img/horizontal_4_1_3009.3a457b10.png";